
import React from "react";

const OutsideMeetingNotice = () => {
  return (
    <div className="outside-container">
      <div className="outside-card">
        {/* Video icon (SVG) */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="outside-icon"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.8"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 7h7a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2z"
          />
        </svg>

        <h2 className="outside-title">Givent works inside Teams meetings</h2>
        <p className="outside-text">
          To start using <strong>Givent</strong>, please open this app during a
          Microsoft Teams meeting or webinar.
        </p>

        <div className="outside-info">
          {/* Info icon (SVG) */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="outside-info-icon"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 110 20 10 10 0 010-20z"
            />
          </svg>
          <span>
            Once opened in a meeting, you can publish and broadcast your form,
            engage participants, and view real-time donations.
          </span>
        </div>

        <a
          href="https://clickandpledge.com/givent"
          target="_blank"
          rel="noreferrer"
          className="outside-button"
        >
          Learn More
        </a>
      </div>

      <p className="outside-footer">
        Need help? Visit{" "}
        <a
          href="https://support.clickandpledge.com"
          target="_blank"
          rel="noreferrer"
          className="outside-link"
        >
          Givent Help Center
        </a>
      </p>
    </div>
  );
};

export default OutsideMeetingNotice;
